import { TrackEventArg, TrackEventArguments } from './types';
import { createConfigParametersRepository } from '../../configParametersRepository';
import { CUSTOM_PARAMS_STORAGE_KEY } from '../resources/constants';
import { CustomParams } from '../google-analytics/ga4Types';
import { createRuntimeGoogleState } from '../init/ga/state';
import { gtagWrapper, getPageLocation } from '../google-analytics/utils';
import { getUserPropertiesFromDimensions } from '../google-analytics/ga4';
import { createFirebaseAdapter } from '../firebase/firebaseAdapter';
import { createFirebaseClient } from '../firebase/firebaseClient';
import { checkGaInit } from '../init/ga';
import { trackUserProperties } from '../../configParametersRepository/storageClient/utils';
import { handleEventError } from './error';

const getStoredScreenName = (): string | undefined => {
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const trackingStorageClient = getTrackingStorageClient();
  const storedCustomParams = trackingStorageClient.getTrackingStoredValue(
    CUSTOM_PARAMS_STORAGE_KEY
  ) as CustomParams;
  return storedCustomParams?.screen_name;
};

export const trackEvent = async ({
  action,
  label,
  page,
  category = 'NOT_DEFINED',
  dimensionsAndParams = {},
}: Partial<TrackEventArguments>) => {
  if (typeof window === 'undefined') return;
  await checkGaInit();
  const { getGoogleState, queueEvent } = createRuntimeGoogleState();
  const { hasThePageBeenTracked } = getGoogleState();

  if (!hasThePageBeenTracked) {
    queueEvent({ action, label, page, category });
    return;
  }

  const options = {
    action,
    label,
    category,
    page: page || getStoredScreenName(),
    dimensionsAndParams,
  };

  trackEventInGa4(options);
};

/**
 * Tracks a Google Analytics 4 event.
 * @param data
 */
export const trackEventInGa4 = (data: TrackEventArg) => {
  const {
    page: screen_name,
    category: event_category,
    action: event_action,
    label: event_label,
    dimensionsAndParams,
  } = data;
  handleEventError({
    action: event_action,
    label: event_label,
    page: screen_name,
    category: event_category,
  });
  if (!screen_name) return;
  const firebaseAdapter = createFirebaseAdapter();
  const firebaseClient = createFirebaseClient(firebaseAdapter);
  const { getTrackingStorageClient } = createConfigParametersRepository();
  const { getTrackingStoredValue } = getTrackingStorageClient();
  const storedCustomParams = getTrackingStoredValue(CUSTOM_PARAMS_STORAGE_KEY);

  const customParams: CustomParams = {
    ...storedCustomParams,
    screen_name,
    event_category,
    event_action,
    event_label,
  };
  trackUserProperties(getUserPropertiesFromDimensions(dimensionsAndParams));
  firebaseClient.trackEvent(customParams);
  gtagWrapper('event', 'edo_event', {
    page_location: getPageLocation(screen_name),
    ...customParams,
  });
};
